import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { UserProfileApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface IUseFamilyContactsGetProps {
  userId: number;
  contactId?: number;
}

export const useFamilyContactsGet = ({
  userId,
  contactId,
}: IUseFamilyContactsGetProps) => {
  const accessToken = useAccessToken();

  const { data, isSuccess, isPending, isError, isFetching, refetch } = useQuery({
    queryKey: [QueryKeys.FamilyContactsGet, userId, contactId ?? "all"],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }

      const service = createAuthenticatedApi(UserProfileApi, accessToken);

      return service.apiUserProfileIdContactsGet({
        id: userId,
        ids: contactId ? [contactId] : undefined,
      });
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isSuccess,
    isError,
    isPending,
    isFetching,
    refetch,
  };
};
